export default __webpack_public_path__ + "static/media/rapport.19739a16.pdf";